import React, { useContext, ReactElement } from 'react'

import { MainButton, SecondaryButton } from '../../pages/main_page/components/style'
import { HeaderContainer, Logo, StyledText, LogoLink } from './style'

import ThemeContext from '@/theme/context'
import { FreeAccess } from '../FreeAccess'
import {ThemedLink} from '@/components/Header/style'

type Props = {
    drupalHost: string
    extraButton?: ReactElement
    currentAct?: string
    translationDay: string
}

export const HeaderComponent = ({ drupalHost, currentAct, translationDay}:Props) => {
    const { logoUrl, title, primaryColor, href, christmasUrl } = useContext(ThemeContext);

    let extraButton,
        mainHref = `//${href ? href + '.' : ''}${drupalHost}`

    switch (currentAct) {
        case 'olymp':
            extraButton = <>
                {translationDay === "y" && <SecondaryButton basic floated='right' $color={primaryColor} href="/cameras">Видеотрансляция</SecondaryButton>}
                <MainButton basic color='grey' floated='right' href={`//test.${drupalHost}/training/olymp/index.html`}>Онлайн-тренинги</MainButton>
            </>
            break;
        case 'fieb':
            extraButton = <>
                {translationDay === "y" && <MainButton primary floated='right' $color={primaryColor} href="/cameras">Видеотрансляция</MainButton>}
                <MainButton className="hiddenMobile" basic color='grey' floated='right' href={`//test.${drupalHost}/fieb/index.html`}>Вход по ключу</MainButton>
            </>
            break;
        case 'test_constructor':
            mainHref += '/test_constructor'
            break;
        case 'fepo_pro':
            extraButton = <>
                {translationDay == "y" && <MainButton primary floated='right' $color={primaryColor} href="/cameras">Видеотрансляция</MainButton>}
            </>
            mainHref += '/fepo_pro'
            break;
        default:
            break;
    }

    const handleRedirect = () => {
        const domen = window.location.host.split('.').at(-1);
        window.location.href = `//olymp-en.i-exam.${domen}/`
    }

    return (
        <HeaderContainer>
            <div>
                <LogoLink href={mainHref}>
                    <Logo verticalAlign="middle" src={logoUrl} />
                </LogoLink>
                <StyledText><a href={mainHref}>{title}</a></StyledText>
            </div>
            <div>
                {extraButton}
                {currentAct && ['ias', 'fepo', 'diag', 'fieb_tren', 'default'].includes(currentAct) && <FreeAccess primaryColor={primaryColor} />}
                {currentAct !== 'olymp_en' && <>
                    <SecondaryButton href={`//auth.${drupalHost}/signup`} basic floated='right' $color={primaryColor}>
                        Зарегистрироваться
                    </SecondaryButton>
                    <MainButton href={`//auth.${drupalHost}`} primary floated='right' $color={primaryColor}>
                        Войти
                    </MainButton>
                </>}
            </div>
        </HeaderContainer>
    )
}
